/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RolloutTargetRemoveRequest { 
    /**
     * List of target IDs.
     */
    target_ids: Set<string>;
}

